import { CreateInstance } from "./config"
const DepartmentExcelUploadAPI = CreateInstance("departments-excel")
export default DepartmentExcelUploadAPI
